export default __webpack_public_path__ + "static/media/8W3A2042.c95b1b45.jpg";